//Notifications.js
import React, { useState } from 'react';
import {
  Box,
  TablePagination,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useOutletContext } from 'react-router-dom';
import { acme, acmePageSectionCardSx, acmeBillingSectionContentSx } from '../../theme/acmeTheme';
import { Card, CardContent, PageHeader, PageBlockTitle } from '../ui';
import {
  NotificationsEmptyState,
  NotificationMobileCard,
  NotificationsDataTable,
} from '../notificationShared';

function Notifications({ inDashboard = false }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const contextData = useOutletContext();
  const notifications = contextData?.notifications || [];
  const markNotificationAsRead = contextData?.markNotificationAsRead || (() => {});

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const displayed = notifications.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const pagination = (
    <TablePagination
      component="div"
      count={notifications.length}
      page={page}
      onPageChange={handleChangePage}
      rowsPerPage={rowsPerPage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      rowsPerPageOptions={[10, 25, 50]}
    />
  );

  const renderMobileNotifications = () => {
    if (notifications.length === 0) {
      return <NotificationsEmptyState />;
    }
    return (
      <Box>
        {displayed.map((n) => (
          <NotificationMobileCard
            key={n._id}
            notification={n}
            onMarkViewed={markNotificationAsRead}
          />
        ))}
      </Box>
    );
  };

  return (
    <Box sx={inDashboard ? { p: 0 } : undefined}>
      {!inDashboard && (
        <PageHeader
          title="All Notifications"
          description="View and manage all system notifications in one place."
          sx={{ mb: 2 }}
        />
      )}

      {isMobile ? (
        <>
          {renderMobileNotifications()}
          <Box sx={{ mt: 2 }}>{pagination}</Box>
        </>
      ) : notifications.length === 0 ? (
        <NotificationsEmptyState />
      ) : inDashboard ? (
        <Box>
          <NotificationsDataTable
            displayed={displayed}
            onMarkViewed={markNotificationAsRead}
          />
          <Box sx={{ px: 1 }}>{pagination}</Box>
        </Box>
      ) : (
        <Card sx={{ ...acmePageSectionCardSx, boxShadow: 'none', overflow: 'hidden', mt: 0 }}>
          <CardContent sx={{ ...acmeBillingSectionContentSx, pb: 0, '&:last-child': { pb: 0 } }}>
            <PageBlockTitle gutterBottom>All Notifications</PageBlockTitle>
            <NotificationsDataTable
              displayed={displayed}
              onMarkViewed={markNotificationAsRead}
            />
            <Box
              sx={{
                px: 2,
                borderTop: `1px solid ${acme.colors.border}`,
              }}
            >
              {pagination}
            </Box>
          </CardContent>
        </Card>
      )}
    </Box>
  );
}

export default Notifications;
